import { defineStore } from "pinia";

export const useDcStore = defineStore('dcStore', {
    state:()=>({
        data:"DC data",
    }),
})